if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    document.addEventListener("DOMContentLoaded", () => {
        const inputSearchSelector = `input[type='search']`;
        let debounceTimer;
        document.addEventListener("input", (e) => {
            if (e.target && e.target.matches(inputSearchSelector)) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    window.dispatchEvent(new Event('scroll'));
                }, 300);
            }
        });
    }); 

    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.id === "mu-checkout-container" || item.target.classList.contains("header__cart__status")) {
                    setTimeout(()=>{
                        updateCartPrices();
                    }, 700)
                }
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }, 300);

    setTimeout(()=>{
        updateCartPrices();
    }, 4000)

    function updateCartPrices() {
        if (
            !BSS_B2B?.storage?.cartStorage?.store ||
            BSS_B2B.storage.cartStorage.store.size === 0
        ) {
            console.warn("Cart storage is empty or unavailable.");
            return;
        }

        const cartMap = new Map();
        BSS_B2B.storage.cartStorage.store.forEach((value) => {
            cartMap.set(String(value.variant_id), value.key);
        });

        document.querySelectorAll(".mu-cart-item").forEach((item) => {
            const variantId = item.getAttribute("data-variant-id");
            const priceElement = item.querySelector(".mu-item-price");

            if (variantId && priceElement) {
            const cartKey = cartMap.get(String(variantId));

            if (cartKey) {
                if (!priceElement.hasAttribute("bss-b2b-cart-item-key")) {
                    priceElement.setAttribute("bss-b2b-cart-item-key", cartKey);
                }
                if (!priceElement.hasAttribute("bss-b2b-item-original-price")) {
                    priceElement.setAttribute("bss-b2b-item-original-price", "");
                }
            }
            }
        });

        const subtotalElement = document.querySelector(".mu-checkout-btn .money");
        if (
            subtotalElement &&
            !subtotalElement.hasAttribute("bss-b2b-cart-total-price")
        ) {
            subtotalElement.setAttribute("bss-b2b-cart-total-price", "");
        }
        
        BSS_B2B?.observer?.cartSubject?.notifyObserver("CartMutate", "CartPriceMutate");
    }


}